<div class="calendar-container">
  <mat-card class="calendar-card">
    <mat-calendar
      #calendar
      [minDate]="minDate"
      (selectedChange)="select($event, calendar)"
      [dateClass]="isSelected"
    ></mat-calendar>
  </mat-card>

  <div class="calendar-actions">
    <button (click)="Save()" class="calendar-save-btn">
      <mat-icon class="btn-icon">save</mat-icon> Save
    </button>
  </div>
</div>
